import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import Home from "./UserApp/Dashboard/Home";
import ContactUs from "./UserApp/Dashboard/Component/ContactUs";
import Career from "./UserApp/Dashboard/Component/Career";
import CareerDetails from "./UserApp/Dashboard/Component/CareerDetails";
import Blog from "./UserApp/Dashboard/Component/Blog";
import BlogDetails from "./UserApp/Dashboard/Component/BlogDetails";
import Services from "./UserApp/Dashboard/Component/Services";
import ServiceDetail from "./UserApp/Dashboard/Component/ServiceDetail";
import AboutUs from "./UserApp/Dashboard/Component/AboutUs";
import PrivacyPolicy from "./UserApp/Dashboard/Component/PrivacyPolicy";
import TermsConditions from "./UserApp/Dashboard/Component/TermsOfCondisions";
import RefundCancellation from "./UserApp/Dashboard/Component/RefundAndCancellation";
import SprintVerify from "./UserApp/Dashboard/Component/SprintVerify";
import RechargeApi from "./UserApp/Dashboard/Component/RechargeApi";
import AepsDmtServices from "./UserApp/Dashboard/Component/AepsDmtServices";
import B2bRechargeSoftware from "./UserApp/Dashboard/Component/B2bRechargeSoftware";
import AndroidAppDevelopment from "./UserApp/Dashboard/Component/AndroidAppDevelopment";
import HostingServices from "./UserApp/Dashboard/Component/HostingServices";
import UtilityBillPayment from "./UserApp/Dashboard/Component/UtilityBillPayment";
import FlightBookingApi from "./UserApp/Dashboard/Component/FlightBookingApi";
import CrmSoftwareSolutions from "./UserApp/Dashboard/Component/CrmSoftwareSolutions";
import DigitalMarketingSolutions from "./UserApp/Dashboard/Component/DigitalMarketingSolutions";
import WebDesigningServices from "./UserApp/Dashboard/Component/WebDesigningServices";
import EcommerceShopping from "./UserApp/Dashboard/Component/EcommerceShopping";
import IndoNepalRemittance from "./UserApp/Dashboard/Component/IndoNepalRemittance";
import FastagRechargeApi from "./UserApp/Dashboard/Component/FastagRechargeApi";
import OttSubscriptionApi from "./UserApp/Dashboard/Component/OttSubscriptionApi";
import CourierBookingApi from "./UserApp/Dashboard/Component/CourierBookingApi";
import AadhaarPayMerchant from "./UserApp/Dashboard/Component/AadhaarPayMerchant";
import MicroAtmPos from "./UserApp/Dashboard/Component/MicroAtmPos";
import RouteSeo from './UserApp/Layout/RouteSeo';


function App() {
  return (
    <Router>
      <div className="App">
        <main>
           <RouteSeo /> 
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact_us" element={<ContactUs />} />
            <Route path="/career" element={<Career />} />
            <Route path="/join_us" element={<CareerDetails />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog_detail" element={<BlogDetails />} />
            <Route path="/services" element={<Services />} />
            <Route path="/service_details" element={<ServiceDetail />} />
            <Route path="/about_us" element={<AboutUs />} />
            <Route path="/privacy_policy" element={<PrivacyPolicy />} />
            <Route path="/terms_of_conditions" element={<TermsConditions />} />
            <Route path="/refund_and_cancellation" element={<RefundCancellation />} />
            <Route path="/sprintverify" element={<SprintVerify />} />
            <Route path="/recharge_api" element={<RechargeApi />} />
            <Route path="/aeps_dmt_services" element={<AepsDmtServices />} />
            <Route path="/b2b_recharge_software" element={<B2bRechargeSoftware />} />
            <Route path="/android_app_development" element={<AndroidAppDevelopment />} />
            <Route path="/hosting_services" element={<HostingServices />} />
            <Route path="/utility_bill_payment" element={<UtilityBillPayment />} />
            <Route path="/flight_booking_api" element={<FlightBookingApi />} />
            <Route path="/crm_software_solutions" element={<CrmSoftwareSolutions />} />
            <Route path="/digital_marketing_solutions" element={<DigitalMarketingSolutions />} />
            <Route path="/web_designing_services" element={<WebDesigningServices />} />
            <Route path="/ecommerce_shopping" element={<EcommerceShopping />} />
            <Route path="/indo_nepal_remittance" element={<IndoNepalRemittance />} />
            <Route path="/fastag_recharge_api" element={<FastagRechargeApi />} />
            <Route path="/ott_subscription_api" element={<OttSubscriptionApi />} />
            <Route path="/courier_booking_api" element={<CourierBookingApi />} />
            <Route path="/aadhaar_pay_merchant" element={<AadhaarPayMerchant />} />
            <Route path="/micro_atm_pos" element={<MicroAtmPos />} />
          </Routes>
        </main>
        
      </div>
      
    </Router>
    
  );
}

export default App;
